function WE_QuizTracking_ReadSessionStorage( key )
{
    var value = null;

    try
    {
        value = window.sessionStorage.getItem( key );
    }
    catch ( e )
    {
        value = null;
    }

    return value;
}

function WE_QuizTracking_WriteSessionStorage( key, value )
{
    try
    {
        window.sessionStorage.setItem( key, value );
    }
    catch ( e )
    {
    }
}

function WE_QuizTracking_GetSessionId( )
{
    var sid       = "";
    var candidate = "";
    var key       = "we_quiz_session_id";

    sid = WE_QuizTracking_ReadSessionStorage( key ) || "";

    if ( sid == "" )
    {
        candidate = "qz-" + Date.now( ).toString( 36 ) + "-" + Math.random( ).toString( 36 ).substr( 2, 8 );
        sid = candidate;
        WE_QuizTracking_WriteSessionStorage( key, sid );
    }

    return sid;
}

function WE_QuizTracking_GetCustomerStatus( )
{
    if ( typeof window._weQuizPageCustomerStatus === "string" && window._weQuizPageCustomerStatus !== "" )
    {
        return window._weQuizPageCustomerStatus;
    }

    var auth = ( window._onboardingQuizData && window._onboardingQuizData.auth ) || null;
    if ( auth && auth.id )
    {
        return "logged_in";
    }

    var wrap = document.getElementById( "lightning-register-wrap" );
    if ( wrap && wrap.getAttribute( "data-customer-logged-in" ) === "true" )
    {
        return "logged_in";
    }

    return "guest";
}

function WE_QuizTracking_NormalizeFunnelStepNumber( raw )
{
    var parsedStepNumber      = null;
    var normalizedStepNumber  = null;

    if ( raw == null || raw == "" )
    {
        normalizedStepNumber = null;
    }
    else
    {
        parsedStepNumber = typeof raw == "number" ? raw : parseInt( String( raw ), 10 );
        if ( parsedStepNumber >= 1 )
        {
            normalizedStepNumber = parsedStepNumber;
        }
        else
        {
            normalizedStepNumber = null;
        }
    }

    return normalizedStepNumber;
}

function WE_QuizTracking_GetFunnelLogLineFromPayload( payload )
{
    var payloadEventName              = payload.event;
    var funnelStepNumber              = WE_QuizTracking_NormalizeFunnelStepNumber( payload.step_number );
    var quizResultsBuiltParam         = payload.quiz_results_built;
    var quizResultsBuiltMatchesGaTrue = ( quizResultsBuiltParam == true || quizResultsBuiltParam == "true" );
    var funnelLogLine                 = null;

    if ( payloadEventName == "quiz_start" )
    {
        funnelLogLine = "Step 1: Quiz Start — quiz_start";
    }
    else if ( payloadEventName == "quiz_step_view" )
    {
        if ( funnelStepNumber == 3 )
        {
            funnelLogLine = "Step 2: Q3 Viewed (25%) — quiz_step_view step_number 3";
        }
        else if ( funnelStepNumber == 6 )
        {
            funnelLogLine = "Step 3: Q6 Viewed (50%) — quiz_step_view step_number 6";
        }
        else if ( funnelStepNumber == 9 )
        {
            funnelLogLine = "Step 4: Q9 Viewed (75%) — quiz_step_view step_number 9";
        }
        else if ( funnelStepNumber == 12 )
        {
            funnelLogLine = "Step 5: Q12 Viewed (100%) — quiz_step_view step_number 12";
        }
    }
    else if ( payloadEventName == "quiz_complete" )
    {
        funnelLogLine = "Step 6: Quiz complete — quiz_complete";
    }
    else if ( payloadEventName == "add_to_cart" && quizResultsBuiltMatchesGaTrue )
    {
        funnelLogLine = "Step 7: Add To Cart — add_to_cart quiz_results_built true";
        if ( payload.quiz_results_items_added != null )
        {
            funnelLogLine += " | quiz_results_items_added=" + payload.quiz_results_items_added;
        }
        if ( payload.quiz_results_products_offered != null )
        {
            funnelLogLine += " | quiz_results_products_offered=" + payload.quiz_results_products_offered;
        }
        if ( payload.quiz_results_added_vs_offered_pct != null )
        {
            funnelLogLine += " | quiz_results_added_vs_offered_pct=" + payload.quiz_results_added_vs_offered_pct;
        }
    }
    else if ( payloadEventName == "quiz_register_view" )
    {
        funnelLogLine = "Quiz register (quiz flow) — quiz_register_view";
    }
    else if ( payloadEventName == "quiz_membership_steps_view" )
    {
        funnelLogLine = "Membership steps (quiz) — quiz_membership_steps_view";
    }
    else if ( payloadEventName == "quiz_ec_begin_checkout" )
    {
        funnelLogLine = "Checkout with quiz EC line(s) — quiz_ec_begin_checkout";
    }

    return funnelLogLine;
}

function WE_QuizTracking_BuildGtagEventParamsFromPayload( payload )
{
    var gtagParams    = { };
    var payloadKey    = "";
    var measurementId = "G-501KLMS406";

    for ( payloadKey in payload )
    {
        if ( Object.prototype.hasOwnProperty.call( payload, payloadKey ) && payloadKey != "event" )
        {
            gtagParams[ payloadKey ] = payload[ payloadKey ];
        }
    }

    if ( typeof measurementId == "string" && measurementId.indexOf( "G-" ) == 0 )
    {
        gtagParams.send_to = measurementId;
    }

    return gtagParams;
}

function WE_QuizTracking_SendGtagIfReady( eventName, gtagParams )
{
    var sent = false;

    if ( window.gtag )
    {
        try
        {
            window.gtag( "event", eventName, gtagParams );
            sent = true;
        }
        catch ( err )
        {
        }
    }

    if ( !sent )
    {
        if ( !window.WE_QuizTracking_GtagMissingWarned )
        {
            window.WE_QuizTracking_GtagMissingWarned = true;
            console.warn( "[WE Quiz GA4] window.gtag not available; quiz events are in dataLayer until the Google tag loads." );
        }
    }
}

function WE_QuizTracking_Push( eventName, extraParams )
{
    var payload     = null;
    var payloadKey  = "";
    var funnelLine  = null;

    window.dataLayer = window.dataLayer || [ ];
    payload =
    {
        event: eventName,
        quiz_name: "welleasy_onboarding_quiz",
        quiz_session_id: WE_QuizTracking_GetSessionId( ),
        customer_status: WE_QuizTracking_GetCustomerStatus( )
    };

    if ( extraParams )
    {
        for ( payloadKey in extraParams )
        {
            if ( Object.prototype.hasOwnProperty.call( extraParams, payloadKey ) )
            {
                payload[ payloadKey ] = extraParams[ payloadKey ];
            }
        }
    }

    if ( window.location && window.location.search && window.location.search.indexOf( "ga_debug=1" ) >= 0 )
    {
        payload.debug_mode = true;
    }

    funnelLine = WE_QuizTracking_GetFunnelLogLineFromPayload( payload );

    if ( funnelLine )
    {
        console.log( "[WE Quiz GA4] " + funnelLine, payload );
    }

    window.dataLayer.push( payload );

    WE_QuizTracking_SendGtagIfReady( eventName, WE_QuizTracking_BuildGtagEventParamsFromPayload( payload ) );
}

function WE_QuizTracking_CartQuizEcLineCount( cart )
{
    var count = 0;

    if ( cart && cart.items && cart.items.length )
    {
        cart.items.forEach( function ( line )
        {
            var p = line.properties;
            if ( p && ( p._enhancedcommerce || p[ "_enhancedcommerce" ] ) )
            {
                count += 1;
            }
        } );
    }

    return count;
}

function WE_QuizTracking_InitCartCache( )
{
    fetch( "/cart.js", { credentials: "same-origin", cache: "no-store" } )
        .then( function ( r ) { return r.json( ); } )
        .then( function ( cart ) { window.WE_QuizTracking_CartCache = cart; } )
        .catch( function ( ) { } );
}

function WE_QuizTracking_MaybePushQuizEcBeginCheckout( )
{
    var cart = window.WE_QuizTracking_CartCache;
    if ( cart )
    {
        var c = WE_QuizTracking_CartQuizEcLineCount( cart );
        if ( c > 0 && typeof WE_QuizTracking_Push === "function" )
        {
            WE_QuizTracking_Push( "quiz_ec_begin_checkout", { quiz_ec_line_count: c } );
        }
    }
}

function WE_QuizTracking_InitQuizEcCheckoutIntent( )
{
    if ( window.WE_QuizTracking_InitQuizEcCheckoutIntentDone )
    {
        return;
    }
    window.WE_QuizTracking_InitQuizEcCheckoutIntentDone = true;

    WE_QuizTracking_InitCartCache( );

    function hrefIsShopifyCheckout( href )
    {
        try
        {
            var u = new URL( href, window.location.href );
            if ( u.hostname !== window.location.hostname )
            {
                return false;
            }
            var p = u.pathname || "";
            return p === "/checkout" || p.indexOf( "/checkouts/" ) === 0;
        }
        catch ( e )
        {
            return false;
        }
    }

    function termsBlockCheckout( )
    {
        var terms = document.getElementById( "terms" );
        return Boolean( terms && !terms.checked );
    }

    document.addEventListener( "click", function ( e )
    {
        if ( e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey )
        {
            return;
        }
        if ( termsBlockCheckout( ) )
        {
            return;
        }
        var a = e.target.closest && e.target.closest( "a[href]" );
        if ( !a || a.target === "_blank" )
        {
            return;
        }
        if ( !hrefIsShopifyCheckout( a.href ) )
        {
            return;
        }
        WE_QuizTracking_MaybePushQuizEcBeginCheckout( );
    } );

    document.addEventListener( "submit", function ( e )
    {
        var form = e.target;
        if ( !form || form.tagName !== "FORM" || !form.querySelector( "[name=\"checkout\"]" ) )
        {
            return;
        }
        if ( termsBlockCheckout( ) )
        {
            return;
        }
        WE_QuizTracking_MaybePushQuizEcBeginCheckout( );
    } );
}

WE_QuizTracking_InitQuizEcCheckoutIntent( );
